import Vimeo from '@u-wave/react-vimeo';

function VideoModal({ video, onClose, onVideoEnd }) {
    const handleVideoEnd = () => {
        if (onVideoEnd) {
            onVideoEnd();
        }
    };

    // Detect landscape orientation
    const isLandscape = typeof window !== 'undefined' && window.innerWidth > window.innerHeight;

    // Calculate max dimensions based on viewport
    // Use 80% of viewport height to ensure controls are always visible
    const maxVideoHeight = typeof window !== 'undefined' 
        ? Math.floor(window.innerHeight * 0.8) 
        : 600;
    
    // Calculate width based on 16:9 aspect ratio from the max height
    const calculatedWidth = Math.floor(maxVideoHeight * (16 / 9));
    
    // Use the smaller of calculated width or 90vw
    const maxVideoWidth = typeof window !== 'undefined'
        ? Math.min(calculatedWidth, window.innerWidth * 0.9, 1400)
        : 1200;

    return (
        <div 
            className="video-modal modal-overlay tw-bg-opacity-95 tw-z-[1000] tw-flex tw-items-center tw-justify-center" 
            style={{
                padding: '16px',
                paddingTop: 'max(env(safe-area-inset-top, 16px), 16px)',
                paddingBottom: 'max(env(safe-area-inset-bottom, 16px), 16px)',
                paddingLeft: 'max(env(safe-area-inset-left, 16px), 16px)',
                paddingRight: 'max(env(safe-area-inset-right, 16px), 16px)',
                overflow: 'auto',
            }}
            onClick={onClose}
        >
            <div 
                className="tw-relative tw-bg-black tw-rounded-xl tw-overflow-visible tw-flex-shrink-0" 
                style={{ 
                    width: '100%',
                    maxWidth: `${maxVideoWidth}px`,
                    aspectRatio: '16 / 9',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button 
                    onClick={onClose} 
                    className="tw-absolute tw-top-4 tw-left-4 tw-z-10 tw-bg-black tw-bg-opacity-70 tw-border-0 tw-rounded-full tw-w-14 tw-h-14 tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-text-white tw-text-4xl hover:tw-bg-opacity-90"
                >
                    ×
                </button>

                <div className="tw-w-full tw-h-full">
                    <Vimeo
                        video={video.embed}
                        autoplay={true}
                        responsive={true}
                        onEnd={handleVideoEnd}
                        style={{ height: '100%', width: '100%' }}
                    />
                </div>
            </div>
        </div>
    );
}

export default VideoModal;
